import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface PaginationState {
  page: number;
  pageSize: number;
}

interface PaginationStore {
  pagination: Record<string, PaginationState>;

  get: (key: string) => PaginationState;
  setPage: (key: string, page: number) => void;
  setPageSize: (key: string, pageSize: number) => void;
  reset: (key?: string) => void;
}

const DEFAULT_PAGINATION: PaginationState = {
  page: 0,
  pageSize: 10,
};

const usePaginationStore = create<PaginationStore>()(
  persist(
    (set, get) => ({
      pagination: {},

      get: (key) => get().pagination[key] ?? DEFAULT_PAGINATION,

      setPage: (key, page) =>
        set((state) => ({
          pagination: {
            ...state.pagination,
            [key]: {
              ...(state.pagination[key] ?? DEFAULT_PAGINATION),
              page,
            },
          },
        })),

      setPageSize: (key, pageSize) =>
        set((state) => ({
          pagination: {
            ...state.pagination,
            [key]: {
              page: 0,
              pageSize,
            },
          },
        })),

      reset: (key) =>
        set((state) => {
          if (key) {
            return {
              pagination: {
                ...state.pagination,
                [key]: DEFAULT_PAGINATION,
              },
            };
          }

          return { pagination: {} };
        }),
    }),
    {
      name: 'pagination-store',
    },
  ),
);

export default usePaginationStore;
